import { render } from "./UiMixin.vue?vue&type=template&id=b3c098ca"
import script from "./UiMixin.vue?vue&type=script&lang=js"
export * from "./UiMixin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__